import { render, staticRenderFns } from "./StagingEditorSectionsTab.vue?vue&type=template&id=1121ecfa"
import script from "./StagingEditorSectionsTab.vue?vue&type=script&lang=ts"
export * from "./StagingEditorSectionsTab.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorSectionsTab.vue?vue&type=style&index=0&id=1121ecfa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports